export const FEATURE_NAME_WEBHOOK = 'webhooks';
export const FEATURE_FACTORY_OPERATOR = 'factory_operator';
export const FEATURE_SECURE_REMOTE_ACCESS = 'secure_remote_access';
export const FEATURE_MAP_OVERVIEW = 'map_overview';
export const FEATURE_ANALYZE_PROJECT = 'analyze_project';
export const FEATURE_VULNERABILITIES = 'vulnerabilities';
export const FEATURE_DEVICE_TELEMETRY = 'device_telemetry';
export const FEATURE_IDEAAS_HUB = 'ideaas_hub';
export const FEATURE_IDEAAS_HUB_DESKTOP_SESSIONS =
  'ideaas_hub_desktop_sessions';
export const FEATURE_CUSTOM_FIELDS = 'custom_fields';
